import { HelmetProvider, Helmet } from "react-helmet-async";

export { HelmetProvider };

export default function SEOHelmet({ seo, projectId, tracking }) {
  if (!seo) return null;

  const uploadsBase =
    process.env.REACT_APP_UPLOADS_URL ||
    "https://microsite.thehomestore.co.in/uploads";

  const rawPrice = seo?.price || "";
  const price = isNaN(Number(rawPrice))
    ? rawPrice.replace(/[^0-9.]/g, "") || "0"
    : rawPrice;

  const floorSizeValue = seo?.floorSize
    ? seo.floorSize.replace(/[^0-9.]/g, "")
    : "0";

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        name: seo?.siteName || "",
        image: seo?.ogImage || "",
        telephone: "+918069368300",
        email: "care@thehomestore.co.in",
        address: {
          "@type": "PostalAddress",
          addressLocality: seo?.city || "",
          addressRegion: seo?.region || "",
          addressCountry: seo?.country || "",
        },
        url: seo?.slug || "",
      },
      {
        "@type": "ApartmentComplex",
        name: seo?.title || "",
        description: seo?.description || "",
        url: seo?.slug || "",
        image:
          seo?.ogImage ||
          `${uploadsBase}/${projectId}_favicon-96x96.png`,
        address: {
          "@type": "PostalAddress",
          addressLocality: seo?.city || "",
          addressRegion: seo?.region || "",
          addressCountry: seo?.country || "",
        },
        offers: {
          "@type": "Offer",
          price,
          priceCurrency: "INR",
          availability: "https://schema.org/InStock",
        },
        floorSize: {
          "@type": "QuantitativeValue",
          value: floorSizeValue,
          unitText: "SQFT",
        },
      },
    ],
  };

  return (
    <Helmet>
      <title>{seo?.title || "Loading..."}</title>
      <meta name="description" content={seo?.description || ""} />
      <meta name="keywords" content={seo?.keywords || ""} />
      <link rel="canonical" href={seo?.slug || ""} />

      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large"
      />

      {/* OG */}
      <meta property="og:title" content={seo?.title || ""} />
      <meta property="og:description" content={seo?.description || ""} />
      <meta property="og:image" content={seo?.ogImage || ""} />
      <meta property="og:url" content={seo?.slug || ""} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={seo?.siteName || ""} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo?.title || ""} />
      <meta name="twitter:description" content={seo?.description || ""} />
      <meta name="twitter:image" content={seo?.twitterImage || ""} />

      {/* Geo */}
      <meta name="geo.placename" content={seo?.city || ""} />
      <meta name="geo.region" content="IN-WB" />

      {/* Favicon */}
      <link
        rel="icon"
        href={`${uploadsBase}/${projectId || "default"}_favicon.webp`}
      />

      {/* Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>

      {/* 🔥 GTM / Analytics */}
      {tracking?.headerScript && (
        <script
          dangerouslySetInnerHTML={{
            __html: tracking.headerScript,
          }}
        />
      )}
    </Helmet>
  );
}